import { Helmet } from 'react-helmet';
import { useEffect } from 'react';

function Dts() {
    useEffect(() => {
        document.body.classList.add('home-page');
        return () => document.body.classList.remove('home-page');
    }, []);

    return (
        <>
            <Helmet>
                <title>ojee / Department of Tegular Sciences</title>
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>
            <iframe
                title="Department of Tegular Sciences"
                src="/redesign-demos/dts/index.html?v=1"
                style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100dvh', border: 0, background: '#06060a', zIndex: 1 }}
            />
        </>
    );
}

export default Dts;
